/* eslint-disable no-restricted-syntax */
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { ThemeService } from '@services/common/theme-switcher.service';

@Component({
  selector: 'app-message-snackbar',
  standalone: true,
  imports: [MatButtonModule, MatSnackBarModule, MatIcon],
  templateUrl: './message-snackbar.component.html',
})
export class MessageSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public themeService: ThemeService,
    public snackBarRef: MatSnackBarRef<MessageSnackbarComponent>
  ) {}

  get cssClass() {
    return 'snackbar-wrapper ' + this.data?.panelClass;
  }
}
